import React, { Suspense } from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/custom.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Loader from "./components/Loader";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import { AppContextProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import {
  EmailTemplate,
  ViewEmailTemplate,
  Customer,
  ViewCustomer,
  Category,
  Service,
  Product,
  Staff,
  Content,
  ViewContent,
  Notifications,
  Faq,
  Banner,
  Calender,
  RewardManager,
  WalletPaymentManager,
  Order,
  ReferralInvitesManager,
  AdminShadowView,
} from "./pages";
import Transactions from "./pages/Transactions";
import VendorPayouts from "./pages/VendorPayouts";
import Users from "./pages/Users";
import Vendors from "./pages/Vendor";
import Ops from "./pages/Ops";
import AdminUser from "./pages/AdminUser";
import Home from "./pages/Auth/Home";
import Profile from "./pages/Auth/Profile";
import SignIn from "./pages/Auth/SignIn";
import SignUP from "./pages/Auth/Register";
import Error from "./pages/Error";
import Forgotpassword from "./pages/Auth/forgetpassword";
import UserManagerPage from "./pages/usermanager";
import OtpIndex from "./pages/Auth/otp";
import ResetPassword from "./pages/Auth/resetpassword";
import AdminOrdersPage from "./pages/OrderList";

// index.js OR App.js (top-level)
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(advancedFormat);


window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {
  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {
  // const { isLoggedIn } = useContext(AuthContext);

  return (
    <Routes>
      <Route path="/login" element={<SignIn />} />
      <Route path="/register" element={<SignUP />} />
      <Route path="/forgot-password" element={<Forgotpassword />} />
      <Route path="/otp" element={<OtpIndex />} />
      <Route path="/reset_password/:token" element={<ResetPassword />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        {/* Auth Routes */}
        {/* <Route path="/chat" element={<UserChat />} /> */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/dashboard" element={<Home />} />
        <Route exact path="/profile" element={<Profile />} />

        <Route exact path="/user" element={<Customer />} />
        <Route exact path="/user/view/:id" element={<ViewCustomer />} />

        <Route exact path="/category" element={<Category />} />

        <Route exact path="/user-manager" element={<UserManagerPage />} />
        <Route exact path="/users" element={<Users />} />
        <Route exact path="/vendors" element={<Vendors />} />
        <Route exact path="/vendors/shadow-view/:gymId" element={<AdminShadowView />} />
        <Route exact path="/ops" element={<Ops />} />
        <Route exact path="/admin-user" element={<AdminUser />} />

        {/* Service  */}
        <Route exact path="/service" element={<Service />} />

        {/* Product  */}
        <Route exact path="/product" element={<Product />} />

        {/* Order List  */}
        <Route exact path="/order-list" element={<AdminOrdersPage />} />

        {/* Staff Route */}
        <Route exact path="/staff" element={<Staff />} />

        {/* Calender Route */}
        <Route exact path="/calender" element={<Calender />} />

        {/* Order Route */}
        <Route exact path="/order" element={<Order />} />

        {/* Financial Manager Routes */}
        <Route exact path="/transactions" element={<Transactions />} />
        <Route exact path="/vendor-payouts" element={<VendorPayouts />} />

        {/* Wallet Payment  */}
        <Route
          exact
          path="/wallet-payment"
          element={<WalletPaymentManager />}
        />

        {/* Banner  */}
        <Route exact path="/banner" element={<Banner />} />

        {/* Reward Route */}
        <Route exact path="/reward-manager" element={<RewardManager />} />
        <Route
          exact
          path="/referral-Manager"
          element={<ReferralInvitesManager />}
        />

        {/* Content  Route */}
        <Route exact path="/content" element={<Content />} />
        <Route exact path="/content/view/:id" element={<ViewContent />} />

        {/* faq Route */}
        <Route exact path="/faq" element={<Faq />} />

        {/* EmailTemplate Routes */}
        <Route exact path="/email-template" element={<EmailTemplate />} />
        <Route
          exact
          path="/email-template/view/:id"
          element={<ViewEmailTemplate />}
        />

        {/* notification */}
        <Route exact path="/notification" element={<Notifications />} />
        {/* 
        <Route exact path="/locations" element={<ServiceLocation />} />
        <Route exact path="/locations/:id" element={<ServiceLocationView />} /> */}
      </Route>
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
